/** 对公充值 /metering/finance/corporate-recharge（corporateRecharge.vue） */
export default {
  corporateRechargePage: {
    emptyNoViewPerm: '暂无查看权限',
    tabNavAria: '财务模块切换',
    tabPublic: '对公充值',
    tabBank: '银企直连',
    phDateStart: '开始时间',
    phDateEnd: '结束时间',
    phTenant: '租户名称/编号',
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    sectionTitle: '对公充值',
    btnRecharge: '对公充值',
    sortDefault: '默认排序',
    colSeqNo: '交易流水号',
    colOccurTime: '操作时间',
    colTenant: '充值租户',
    colRechargeAccount: '充值账户',
    colAmount: '充值金额',
    colPayeeName: '汇款账户',
    colBankNumber: '汇款账号',
    colTransferRemark: '汇款备注',
    colStatus: '状态',
    colAction: '操作',
    btnView: '查看',
    dialogTitleRecharge: '对公充值',
    dialogTitleVoucher: '收款单',
    formProjectName: '项目名称',
    phSelectProject: '请选择项目',
    formTenantName: '租户名',
    phSelectTenant: '请选择租户',
    formTradeType: '交易类型',
    phSelectTradeType: '请选择交易类型',
    tradeTypeTenantCharge: '租户充值',
    formBizType: '业务类型',
    bizElectric: '电费',
    bizWater: '水费',
    formAmount: '充值金额',
    phAmount: '请输入充值金额',
    suffixYuan: '元',
    formBankType: '银行类型',
    phSelectBankType: '请选择银行类型',
    formRemark: '备注',
    phRemark: '请输入备注',
    formVoucher: '收款单',
    uploadTip: '支持jpg/png格式，单个文件不超过2MB，最多上传5张',
    btnCancel: '取消',
    btnConfirmRecharge: '确定充值',
    btnSubmitting: '提交中...',
    shortcutYesterday: '昨天',
    shortcutThisWeek: '本周',
    shortcutLastWeek: '上周',
    shortcutThisMonth: '本月',
    shortcutLastMonth: '上月',
    shortcutLast3Months: '近三个月',
    shortcutLastYear: '近一年',
    statusNormal: '正常',
    statusRevoked: '已撤销',
    accountElectric: '电费专户',
    accountWater: '水费专户',
    bankZGYH: '中国银行',
    bankPFYH: '浦发银行',
    bankZGYHSZ: '中国银行',
    bankZHSHYH: '招商银行',
    bankZXYH: '中信银行',
    bankNBYH: '宁波银行',
    msgTenantListFail: '获取租户列表失败',
    msgFetchFail: '获取数据失败',
    msgFetchRecordFail: '获取充值记录失败',
    msgNoDataExport: '暂无数据可导出',
    msgExportOk: '已导出 {count} 条',
    msgExportFail: '导出失败',
    exportSheetName: '对公充值',
    filePrefix: '对公充值',
    exportCurrentPage: '导出本页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    warnNoSelectedExport: '请先选择要导出的数据',
    msgExportOkSelected: '已导出选中 {count} 条',
    successExported: '已导出 {count} 条',
    successExportedLimit: '数据量超过 {total} 条，已导出前 {count} 条',
    exporting: '导出中...',
    msgNoOperatePerm: '暂无操作权限',
    msgNoPublicRechargePerm: '该项目暂无对公充值权限',
    msgConfirmSubmit: '确认提交充值申请？',
    confirmTitle: '提示',
    confirmOk: '确定',
    confirmCancel: '取消',
    msgSubmitSuccess: '充值申请提交成功',
    msgPayFail: '充值失败',
    msgRechargeFail: '充值失败',
    msgUploadSuccess: '上传成功',
    msgUploadFail: '上传失败',
    ruleSelectProject: '请选择项目',
    ruleSelectTenant: '请选择租户',
    ruleSelectTradeType: '请选择交易类型',
    ruleSelectBizType: '请选择业务类型',
    ruleAmountRequired: '请输入充值金额',
    ruleAmountInvalid: '请输入有效的金额',
    ruleAmountPositive: '充值金额必须大于0',
    ruleAmountMax: '充值金额不能超过999999.99元',
    ruleSelectBankType: '请选择银行类型'
  }
}
